export const  StatusObj = {
    Disable: 0,
    Available: 1,
    NotAvailable: 2,
    BookByOther: 3,
    BookByYou: 4,
}